module.exports = __webpack_public_path__ + "img/new1-img1.90a1a6fc.png";